import {Action} from '@ngrx/store';
import {type} from '../../shared';

export const resetOrdersActionTypes = {
  RESET: type('[Reset orders] RESET'),
  RESET_SUCCESS: type('[Reset orders] RESET Success'),
  RESET_FAIL: type('[Reset orders] RESET Fail')
};

export class ResetOrdersAction implements Action {
  readonly type = resetOrdersActionTypes.RESET;
  constructor(public payload?: {'orderUuids': string[]}) {}
}

export class ResetOrdersSuccessAction implements Action {
  readonly type = resetOrdersActionTypes.RESET_SUCCESS;
  constructor(public payload?: string[] ) {}
}

export class ResetOrdersFailAction implements Action {
  readonly type = resetOrdersActionTypes.RESET_FAIL;
  constructor(public payload?: string) {}
}
